
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  PlatformSubsidiariesResource,
} from '../models';
import {
    PlatformSubsidiariesResourceFromJSON,
    PlatformSubsidiariesResourceToJSON,
} from '../models';

/**
 * 
 */
export class PlatformSubsidiaryApi extends runtime.BaseAPI {

    /**
     * Find all platform subsidiaries
          */
    async findAllRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PlatformSubsidiariesResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<PlatformSubsidiariesResource>({
            path: `/client-settings/api/platform-subsidiaries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=PlatformSubsidiariesResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Find all platform subsidiaries
          */
    async findAll(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PlatformSubsidiariesResource> {
        const response = await this.findAllRaw(initOverrides);
        return response._data;
    }

}
